import { Head, useForm } from "@inertiajs/react";

import AdminUserForm from "/components/Admin/AdminUserForm";

export default function AdminUsersNew({
}) {
  const { data, setData, post, errors } = useForm({ photo: {} });

  const handleSubmit = (e) => {
    e.preventDefault();

    post("/admin/admin_users");
  };

  return (
    <>
      <Head>
        <title>Новый пользователь</title>
      </Head>

      <AdminUserForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        errors={errors}
      />
    </>
  );
}
